<template>
  <q-layout
      view="hHh Lpr lff">

    <!--app-header :show-login="true"></app-header-->

    <div v-if="this.authStore.isLoggedIn">

      <q-drawer
          :width="layoutStore.getDrawerWidth"
          :breakpoint="300"
          v-model="this.getLeftSideState"
          :mini="!this.getLeftSideState || this.layoutStore.miniState"
          @click.capture="drawerClick"
          side="left"
          v-if="!closing&&this.authStore.isLoggedIn"
      >
        <!-- Resize handle (right edge) -->
        <div v-if="!this.layoutStore.miniState"
             class="drawer-resize-handle"
             @mousedown.prevent="onDrawerResizeStart"
        />
        <div class="drawer-flex">

          <!-- Haut du tiroir (hauteur fixe) : barre utilisateur PUIS bascule
               société. Le menu ci-dessous scrolle. -->
          <div v-if="this.getLeftSideState && !this.layoutStore.miniState" class="drawer-top">
            <!-- Barre utilisateur : photo (si présente) + prénom + langue + thème + déconnexion. -->
            <div v-if="currentUser" class="footer-bar q-mx-sm q-mt-sm">
              <div class="footer-bar__user">
                <q-avatar size="30px" class="footer-avatar cursor-pointer" @click="goToPorfil">
                  <img v-if="currentUser.profil_image" crossorigin="anonymous" :src="currentUser.profil_image">
                  <q-icon v-else name="person" color="white" />
                </q-avatar>
                <span class="footer-name">{{ currentUser.firstName || currentUser.firstname || '' }}</span>
                <q-space />
                <q-btn size="sm" flat round dense color="white" icon="home" @click="goToRoot">
                  <q-tooltip>{{ $t('common.home') || 'Accueil' }}</q-tooltip>
                </q-btn>
                <app-notification-bell />
              </div>

              <!-- Bascule société / espace recruteur intégrée dans la card,
                   séparée par un trait (recruteurs uniquement). -->
              <template v-if="appMenuStore.hasRecruiterMenus">
                <q-separator class="footer-bar__sep" />
                <app-recruiter-mode-switch />
              </template>
            </div>
          </div>

          <!-- Bouton de réduction du menu (mode mini), descendu sous les 2 cards. -->
          <div class="q-mini-drawer-hide collapse-row">
            <q-btn size="sm" dense flat color="app" icon="chevron_left" @click="setMiniState">
              <q-tooltip>{{ $t('common.collapse') || 'Réduire le menu' }}</q-tooltip>
            </q-btn>
          </div>

          <q-scroll-area class="drawer-scroll">

            <!-- Entrée fixe : ouvre le module Raccourcis (épinglés + récents). -->
            <q-item
                clickable
                v-ripple
                class="menu-item home-item q-mx-sm q-my-xs"
                @click="goToShortcuts"
            >
              <q-item-section avatar>
                <q-icon name="bookmarks" size="20px" class="menu-icon"/>
              </q-item-section>
              <q-item-section>
                <q-item-label>{{ tt('app.shortcut.title', 'Raccourcis') }}</q-item-label>
              </q-item-section>
              <q-item-section v-if="pinnedCount" side>
                <q-badge rounded color="app" :label="pinnedCount"/>
              </q-item-section>
            </q-item>
            <q-separator class="q-mx-md q-my-xs"/>

            <div v-if="menus">
              <!-- L'entrée « Accueil » est désormais dans la barre utilisateur (bouton home). -->
              <tree-menu
                  v-for="(item,idx) in menus"
                  v-bind:key="idx"
                  :menu-item="item"
                  :depth="0"
                  @item-clicked="handleMenuItemClick"
              ></tree-menu>

            </div>


            <!--q-item class="q-ma-sm navigation-item" clickable @click="doDisConnect">
              <q-item-section avatar>
                <q-icon size="xs" name="power_settings_new"/>
              </q-item-section>

              <q-item-section>
                <q-item-label>{{ this.$t('common.disconnectTitle') }}</q-item-label>
                <q-item-label style="color:grey">{{ this.$t('common.disconnectHint') }}</q-item-label>
              </q-item-section>
            </q-item-->


          </q-scroll-area>

          <!-- Footer sticky : langue + thème + déconnexion (même style indigo). -->
          <div v-if="currentUser && this.getLeftSideState && !this.layoutStore.miniState"
               class="drawer-bottom q-mx-sm q-mb-sm">
            <div class="footer-bar">
              <div class="footer-bar__user">
                <!-- Numéros de build (commit git) interface / serveur, avec leur date. -->
                <q-btn v-if="frontBuild || backBuild" size="sm" flat round dense color="white" icon="tag">
                  <q-tooltip>Version</q-tooltip>
                  <q-menu anchor="top left" self="bottom left" :offset="[0, 6]">
                    <q-list dense style="min-width: 230px">
                      <q-item-label header>Version</q-item-label>
                      <q-item v-if="frontBuild">
                        <q-item-section avatar><q-icon name="web" size="xs"/></q-item-section>
                        <q-item-section>
                          <q-item-label>Interface <span class="drawer-build">{{ frontBuild }}</span></q-item-label>
                          <q-item-label v-if="frontBuildDate" caption>{{ frontBuildDate }}</q-item-label>
                        </q-item-section>
                      </q-item>
                      <q-item v-if="backBuild">
                        <q-item-section avatar><q-icon name="dns" size="xs"/></q-item-section>
                        <q-item-section>
                          <q-item-label>Serveur <span class="drawer-build">{{ backBuild }}</span></q-item-label>
                          <q-item-label v-if="backBuildDate" caption>{{ backBuildDate }}</q-item-label>
                          <q-item-label v-else-if="backStartedAt" caption>démarré le {{ backStartedAt }}</q-item-label>
                        </q-item-section>
                      </q-item>
                    </q-list>
                  </q-menu>
                </q-btn>
                <app-language></app-language>
                <q-space />
                <q-btn v-if="canAuthorizeAgent" size="sm" flat round dense color="white" icon="vpn_key" @click="openAgentEnroll">
                  <q-tooltip>{{ $te('aia.agent.enrollTitle') ? $t('aia.agent.enrollTitle') : 'Autoriser un PC' }}</q-tooltip>
                </q-btn>
                <q-btn size="sm" flat round dense color="white" :icon="isDarkMode ? 'dark_mode' : 'light_mode'" @click="toggleMode">
                  <q-tooltip>{{ isDarkMode ? 'Mode clair' : 'Mode sombre' }}</q-tooltip>
                </q-btn>
                <q-btn size="sm" flat round dense color="white" icon="power_settings_new" @click="doDisConnect">
                  <q-tooltip>{{ $t('appConnect.disconnectTitle') }}</q-tooltip>
                </q-btn>
              </div>
            </div>
          </div>

        </div>

      </q-drawer>

    </div>

    <!-- AI Chat Drawer (right side) — sur toutes les pages, landings (meta.portal) comprises, dès que l'utilisateur est connecté -->
    <aia-chat-drawer v-can="'APP_GLOBAL_CHAT_BOT'" v-if="this.authStore.isLoggedIn" />

    <q-page-container>
      <router-view/>
    </q-page-container>

    <!-- AI Chat FAB Button (se masque lui-même quand le drawer est ouvert) -->
    <aia-chat-toggle-button v-can="'APP_GLOBAL_CHAT_BOT'" v-if="this.authStore.isLoggedIn && !layoutStore.hideChatButton"/>

    <!-- Fenêtre « Autoriser un PC » (agent déployé par MSI / GPO) : ouvrable de partout, sans passer par l'écran Agent.
         Composant fourni par le module AIA via l'enregistrement global (aucun import statique : core reste découplé). -->
    <aia-agent-enroll-launcher v-if="this.authStore.isLoggedIn && canAuthorizeAgent" />

    <!-- Incitation à activer les notifications push (1re fois, non bloquant) -->
    <app-push-prompt v-if="this.authStore.isLoggedIn && !$route.meta?.portal" />
  </q-layout>
</template>

<script>
import {mapStores} from "pinia";
import {useLayoutStore} from '@core/stores/layoutStore';
import {useAuthStore} from '@core/stores/authStore';

import AuthService from '@core/services/app/authService'
import NavigationService from "@core/services/utils/appNavigationService";

import {Dark} from "quasar";
import {useAppMenuStore} from '@core/stores/app/appMenuStore';
import AppLanguage from '@core/components/language/appLanguage.vue';
import {useUserMenuStore} from '@core/stores/app/userMenuStore';
import AppMenuService from "@core/services/app/appMenuService";
import TreeMenu from '@core/components/menu/TreeMenu.vue';
import AppRecruiterModeSwitch from "@core/components/common/appRecruiterModeSwitch.vue";
import AppNotificationBell from "@core/components/app/appNotificationBell.vue";
import AppPushPrompt from "@core/components/app/appPushPrompt.vue";
import AppUpdateService from "@core/services/app/appUpdateService";
import {useAppMenuShortcutStore} from '@core/stores/app/appMenuShortcutStore';
import AppMenuShortcutService from "@core/services/app/appMenuShortcutService";
// L'assistant IA (aia-chat-drawer / aia-chat-toggle-button) est fourni via
// l'enregistrement global des composants (registerCustomComponents) — aucun import
// statique de remote-aia ici pour garder core découplé. Le FAB gère lui-même sa
// visibilité selon l'état du drawer (plus de dépendance au store aiaChat dans core).

export default {
  data() {
    return {
      miniState: false,
      closing: false,
      left: false,
      contractAddress: "Not set",
      toggleChat : true
    };
  },
  components: {
    AppRecruiterModeSwitch,
    AppNotificationBell,
    AppPushPrompt,
    TreeMenu,
    AppLanguage
  },
  computed: {
    /** Autoriser un PC : réservé aux profils qui ont accès à l'agent (rôle ROLE_AIA_AGENT) et aux administrateurs. */
    canAuthorizeAgent() {
      return !!(this.authStore.hasPermission('ROLE_AIA_AGENT') || this.authStore.hasPermission('ROLE_ADMIN'));
    },
    ...mapStores(useLayoutStore, useAuthStore, useUserMenuStore, useAppMenuStore, useAppMenuShortcutStore),
    pinnedCount() {
      return this.appMenuShortcutStore.pinnedItems.length
    },
    menus() {
      // Menu filtré selon le mode candidat/recruteur (cf. appMenuStore.visibleMenus).
      // La bascule de mode est dans le header (appRecruiterModeSwitch).
      return this.appMenuStore.visibleMenus
    },
    getLeftSideState() {
      return this.layoutStore.getLeftSideState
    },
    currentUser() {
      return this.authStore.currentUser
    },
    isDarkMode() {
      return Dark.mode
    },
    frontBuild() {
      return AppUpdateService.frontBuild
    },
    frontBuildDate() {
      return AppUpdateService.formatDate(AppUpdateService.frontBuildDate)
    },
    backBuild() {
      return AppUpdateService.backBuild
    },
    backBuildDate() {
      return AppUpdateService.formatDate(AppUpdateService.backBuildDate)
    },
    backStartedAt() {
      return AppUpdateService.formatDate(AppUpdateService.backStartedAt)
    },
  },
  methods: {
    openAgentEnroll() {
      window.dispatchEvent(new CustomEvent('aia-agent-enroll'));
    },
    tt(key, fallback) {
      const v = this.$t(key);
      return (!v || v === key) ? fallback : v;
    },
    goToShortcuts() {
      NavigationService.push({name: 'app-shortcuts'})
      if (this.$q.screen.lt.md) {
        this.layoutStore.setLeftSideState(false)
      }
    },
    setMiniState() {
      this.layoutStore.setMiniState(true)
    },
    toggleMode() {
      this.layoutStore.toggleDarkMode()
      Dark.toggle()
      //this.doClose()
    },
    /** Avatar : ouvre le profil ; le menu n'est fermé qu'en mobile (laissé tel quel en desktop) */
    goToPorfil() {
      NavigationService.goToPersonalProfil(this.authStore.currentUser.id)
      if (this.$q.screen.lt.md) {
        this.layoutStore.setLeftSideState(false)
      }
    },
    drawerClick(e) {
      // if in "mini" state and user
      // click on drawer, we switch it to "normal" mode
      if (this.layoutStore.miniState) {
        this.layoutStore.setMiniState(false)

        // notice we have registered an event with capture flag;
        // we need to stop further propagation as this click is
        // intended for switching drawer to "normal" mode only
        e.stopPropagation()
      }
    },

    async doDisConnect() {
      this.closing = true
      this.$nextTick(async () => {
        await AuthService.disconnect();
        await NavigationService.goToHome()
        // Mandatory
        window.location.reload();
      });
    },

    goToRoot() {
      this.$router.push('/')
      if (this.$q.screen.lt.md) {
        this.layoutStore.setLeftSideState(false)
      }
    },

    handleMenuItemClick(menuItem) {
      if (!menuItem) return
      let navigated = false
      if (menuItem.goTo && menuItem.mode === 'panel') {
        NavigationService.push({
          name: menuItem.route.name,
          params : {itemId : menuItem.id}
        })
        navigated = true
      } else if (menuItem.goTo) {
        NavigationService.push({
          name: menuItem.route.name
        })
        navigated = true
      }

      // En viewport mobile, on ferme la sidebar APRÈS une navigation (mais pas
      // quand on déplie simplement un menu parent). On se base sur $q.screen
      // (réactif au viewport) et non sur Platform.is.mobile (détection device
      // uniquement → faux en mode responsive sur desktop).
      if (navigated && this.$q.screen.lt.md) {
        this.layoutStore.setLeftSideState(false)
      }
    },

    onDrawerResizeStart() {
      this._drawerResizing = true;
      document.addEventListener('mousemove', this.onDrawerResizeMove);
      document.addEventListener('mouseup', this.onDrawerResizeEnd);
      document.body.style.cursor = 'col-resize';
      document.body.style.userSelect = 'none';
    },

    onDrawerResizeMove(e) {
      this.layoutStore.setDrawerWidth(e.clientX);
    },

    onDrawerResizeEnd() {
      if (!this._drawerResizing) return;
      this._drawerResizing = false;
      document.removeEventListener('mousemove', this.onDrawerResizeMove);
      document.removeEventListener('mouseup', this.onDrawerResizeEnd);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    },
  },
  watch: {
    currentUser: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          // Autorités fraîches (actions accordées depuis le login) : sans re-login, v-can reflète les droits du profil.
          AuthService.refreshCurrentUser()
          AppMenuService.loadMenu()
          AppMenuShortcutService.load()
        }
      }
    }
  },

  beforeUnmount() {
    this.onDrawerResizeEnd();
  },

  async created() {
  },
};
</script>

<style lang="scss">

// Tiroir GAUCHE (menu) : fond du thème en LIGHT mode (--app-bg, indigo très clair
// pour Skilloscope ; blanc en repli pour rms/talent/modular). Le dark mode reste
// géré par Quasar. `q-drawer--left` pour ne pas toucher le drawer de chat IA (droite).
.body--light .q-drawer--left {
  background: var(--app-bg, #fff);
}

.navigation-item {
  border-radius: 5px;
  margin-top: 2px;
  margin-bottom: 2px;
  font-size: 14px;
}

// Barre utilisateur du footer, façon « bouton » indigo plein, texte blanc.
.footer-bar {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 5px 6px;
  border-radius: 12px;
  // Dégradé aux couleurs de la marque active (tokens --app-*). Fallback indigo
  // Skilloscope ; pour les marques sans token `dark` (talent/modular) on assombrit
  // la primaire via color-mix.
  background: linear-gradient(135deg,
    var(--app-primary, #4f46e5) 0%,
    var(--app-dark, color-mix(in srgb, var(--app-primary, #4f46e5) 72%, #000)) 100%);
  box-shadow: 0 4px 12px rgba(var(--app-primary-rgb, 79, 70, 229), 0.32);
  color: #fff;

  &__user {
    display: flex;
    align-items: center;
    gap: 11px;
  }
  // Trait séparateur entre la barre utilisateur et la bascule recruteur.
  &__sep {
    background: rgba(255, 255, 255, 0.25);
    margin: 0 2px;
  }
  // Le mode-switch n'a plus de fond propre (cf. appRecruiterModeSwitch) : il
  // partage le fond violet de la card. On garde juste un léger retrait latéral.
  :deep(.ms-inline) { padding: 0 2px 2px; }

  .footer-avatar {
    background: rgba(255, 255, 255, 0.18);
    border: 1px solid rgba(255, 255, 255, 0.4);
  }
  .footer-name {
    font-weight: 600;
    color: #fff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
// Commit git dans le menu « Version » du footer.
.drawer-build {
  font-family: monospace;
  opacity: 0.75;
}

.body--dark .footer-bar {
  background: linear-gradient(135deg,
    var(--app-dark, #4338ca) 0%,
    var(--app-deep, color-mix(in srgb, var(--app-primary, #4338ca) 55%, #000)) 100%);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.45);
}

// Tiroir en colonne flex : la zone menu scrolle, le bas (switch + user) garde
// sa hauteur naturelle. Évite que les dernières entrées passent sous le footer.
.drawer-flex {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.drawer-scroll {
  flex: 1 1 auto;
  min-height: 0;   // indispensable pour que le q-scroll-area puisse rétrécir et défiler
}
// Haut du tiroir (utilisateur + société), hauteur fixe, séparé du menu par une bordure basse.
.drawer-top {
  flex: 0 0 auto;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  padding-bottom: 6px;
}
.body--dark .drawer-top { border-bottom-color: rgba(255, 255, 255, 0.12); }

// Footer sticky du tiroir (langue / thème / déconnexion) : hauteur naturelle,
// reste collé en bas car .drawer-scroll absorbe l'espace restant (flex: 1).
.drawer-bottom {
  flex: 0 0 auto;
}

// Bouton « réduire le menu » descendu sous les 2 cards, aligné à droite.
.collapse-row {
  flex: 0 0 auto;
  display: flex;
  justify-content: flex-end;
  padding: 2px 6px;
}

// Look des entrées de menu (les styles .menu-item de TreeMenu sont scoped et
// n'atteignent pas l'entrée « Accueil » rendue ici) : on les réplique pour un
// rendu homogène avec les autres entrées du tiroir.
.menu-item {
  border-radius: 8px;
  min-height: 40px;
  color: var(--q-app);
  transition: all 0.2s ease-in-out;

  .q-item__section--avatar {
    min-width: 40px;
  }

  .menu-icon {
    color: var(--q-app);
    opacity: 1;
  }

  &:hover {
    background: rgba(0, 0, 0, 0.03);
    color: #202124;
  }
}

// Entrée « Accueil » : aux couleurs de l'app (texte + icône + léger fond teinté).
.home-item {
  color: var(--q-app);
  background: color-mix(in srgb, var(--q-app) 8%, transparent);

  .q-item__label,
  .menu-icon {
    color: var(--q-app);
    font-weight: 600;
  }

  &:hover {
    background: color-mix(in srgb, var(--q-app) 14%, transparent);
    color: var(--q-app);
  }
}

// Dark : la primaire de marque (navy rms…) est illisible sur fond sombre.
.body--dark .home-item {
  background: rgba(255, 255, 255, 0.06);

  .q-item__label,
  .menu-icon {
    color: #e8eaed;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
}

.tab-active {
  background-color: $app;
}

.drawer-resize-handle {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  cursor: col-resize;
  z-index: 1000;
  background: transparent;
  transition: background 0.15s;
}
.drawer-resize-handle:hover,
.drawer-resize-handle:active {
  background: rgba(0, 0, 0, 0.12);
}

</style>
